import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-108723c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "btn-ios-download",
  href: "https://apps.apple.com/us/app/topo-fire/id6446780541?platform=iphone"
}
const _hoisted_3 = {
  key: 1,
  class: "btn-ios-download",
  href: "https://itunes.apple.com/us/app/topo-maps+/id672246353?mt=8&at=1000lpce"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "btn-mac-download",
  href: "https://apps.apple.com/us/app/topo-fire/id6446780541?platform=mac"
}
const _hoisted_6 = {
  key: 1,
  class: "btn-mac-download",
  href: "https://itunes.apple.com/us/app/topo-maps/id1441675937?mt=12"
}

import { computed } from "vue";
import { parseService } from "@/services/parse.service";

interface Props {
  centered?: boolean;
  showios?: boolean;
  showMac?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    centered: { type: Boolean, default: false },
    showios: { type: Boolean, default: true },
    showMac: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { centered: boolean, showios: boolean, showMac: boolean }

const isTopoFire = computed(() => {
  return parseService.isTopoFireApp();
});





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex", { 'justify-content-center': __props.centered }]),
    "data-wow-delay": "0.2s"
  }, [
    (__props.showios)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(isTopoFire))
            ? (_openBlock(), _createElementBlock("a", _hoisted_2))
            : (_openBlock(), _createElementBlock("a", _hoisted_3))
        ]))
      : _createCommentVNode("", true),
    (__props.showMac)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(isTopoFire))
            ? (_openBlock(), _createElementBlock("a", _hoisted_5))
            : (_openBlock(), _createElementBlock("a", _hoisted_6))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})